import {icon} from '#core/utils/style-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';

import {generateCloseButton, CLOSE_BUTTON_TYPES} from '#core/application/modules/tiles/close-button/index.js';
import {generateMiniEventItem} from '#core/application/modules/tiles/mini-event-item/index.js';

export function quickNavigationsFactory(PALETTE) {
    const {FONT} = PALETTE;

    const NAVIGATION_CONTAINER_STYLE = {
        style: {
            padding: 0,
        },
    };
    const NAVIGATION_TITLE_CONTAINER_STYLE = {
        style: {
            ...resolveBackground(PALETTE.QUICK_NAVIGATIONS_TITLE_CONTAINER_BG),
            margin: '0 0 4px',
        },
    };
    const NAVIGATION_TITLE_COUNTRY_ICON_STYLE = {
        icon: icon(PALETTE.QUICK_NAVIGATIONS_TITLE_ICON_COLOR),
    };
    const NAVIGATION_TITLE_STYLE = {
        style: PALETTE.QUICK_NAVIGATIONS_TITLE_TEXT,
    };
    const NAVIGATION_ITEMS_CONTAINER_STYLE = {
        separator: {
            style: {
                color: PALETTE.QUICK_NAVIGATIONS_ITEMS_DIVIDER,
            },
        },
    };

    return {
        AppOverlay: {
            quickNavigationDialog: {
                closeButton: generateCloseButton(PALETTE.CLOSE_BUTTON, CLOSE_BUTTON_TYPES.CIRCULAR),
                background: {
                    ...resolveBackground(PALETTE.QUICK_NAVIGATIONS_DIALOG_BG),
                },
                borderStyle: {
                    borderRadius: PALETTE.QUICK_NAVIGATIONS_DIALOG_BORDER_RADIUS,
                },
            },
        },
        QuickEventsNavigation: {
            container: NAVIGATION_CONTAINER_STYLE,
            groupHeaderContainer: NAVIGATION_TITLE_CONTAINER_STYLE,
            countryIcon: NAVIGATION_TITLE_COUNTRY_ICON_STYLE,
            groupHeaderLabel: NAVIGATION_TITLE_STYLE,
            eventItemsContainer: NAVIGATION_ITEMS_CONTAINER_STYLE,
            eventItem: generateMiniEventItem(PALETTE.EVENTS_MINI_EVENT_ITEM),
        },
        QuickLeaguesNavigation: {
            container: NAVIGATION_CONTAINER_STYLE,
            headerContainer: NAVIGATION_TITLE_CONTAINER_STYLE,
            countryIcon: NAVIGATION_TITLE_COUNTRY_ICON_STYLE,
            headerLabel: NAVIGATION_TITLE_STYLE,
            leaguesContainer: NAVIGATION_ITEMS_CONTAINER_STYLE,
            leagueItem: {
                button: {
                    style: {
                        base: {
                            ...resolveBackground(PALETTE.LEAGUES_MINI_EVENT_ITEM.MINI_EVENT_ITEM_BG),
                        },
                        active: {
                            ...resolveBackground(PALETTE.LEAGUES_MINI_EVENT_ITEM.MINI_EVENT_ITEM_SELECTED_BG),
                        },
                    },
                },
                buttonLabel: {
                    style: {
                        fontSize: FONT.SIZE_MEDIUM,
                        fontWeight: FONT.WEIGHT_NORMAL,
                        ...PALETTE.LEAGUES_MINI_EVENT_ITEM.MINI_EVENT_ITEM_CONTENT.MINI_EVENT_ITEM_PARTICIPANTS
                            .PARTICIPANTS_TEXT,
                    },
                },
                buttonLabelActive: {
                    style: {
                        ...PALETTE.LEAGUES_MINI_EVENT_ITEM.MINI_EVENT_ITEM_SELECTED_CONTENT.MINI_EVENT_ITEM_PARTICIPANTS
                            .PARTICIPANTS_TEXT,
                    },
                },
                buttonIcon: icon(
                    PALETTE.LEAGUES_MINI_EVENT_ITEM.MINI_EVENT_ITEM_CONTENT.MINI_EVENT_ITEM_CHEVRON_ICON_COLOR
                ),
                buttonIconActive: icon(
                    PALETTE.LEAGUES_MINI_EVENT_ITEM.MINI_EVENT_ITEM_SELECTED_CONTENT.MINI_EVENT_ITEM_CHEVRON_ICON_COLOR
                ),
            },
        },
    };
}
